import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import infoIcon from "../assets/images/infobtnblue.svg";
import { commonservices } from "../services/CommonServices";
import CKeditorComponent from "../component/common-component/CKeditorComponent";

const AddEditFaqModal = ({
  showModal,
  closeModal,
  faqDetail,
  handleFaqList,
}) => {
  const [faqInput, setFaqInput] = useState({
    question: faqDetail?.que ? faqDetail?.que : "",
    answer: faqDetail?.ans ? faqDetail?.ans : "",
    errors: {
      question: "",
      answer: "",
      ValidationRules: [
        {
          FieldName: "question",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "answer",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });

  const handleSubmit = () => {
    let obj = commonservices.fnCheckValidationOfObject(faqInput);
    if (!obj.isValid) {
      setFaqInput({
        ...obj.obj,
      });
      return;
    }
    handleFaqList({
      id: faqDetail?.id,
      question: faqInput?.question,
      answer: faqInput?.answer,
    });
    closeModal();
  };

  const handleCKEditor = (content, tag) => {
    setFaqInput({
      ...faqInput,
      [tag]: content,
      errors: {
        ...faqInput.errors,
        [tag]: "",
      },
    });
  };
  const fnInputChange = (value, tag) => {
    if (value) {
      setFaqInput({
        ...faqInput,
        [tag]: value,
        errors: {
          ...faqInput.errors,
          [tag]: "",
        },
      });
    } else {
      setFaqInput({
        ...faqInput,
        [tag]: "",
      });
    }
  };
  useEffect(() => {
    const cleanup = commonservices.setupKeyPressHandler(handleSubmit);
    return cleanup;
  }, [handleSubmit]);
  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showModal}
      onHide={closeModal}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{`${
          faqDetail?.id >= 0 ? "Edit" : "Add"
        } Frequently Asked Questions (FAQs)`}</Modal.Title>
      </Modal.Header>
      <Form>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="form-group mb16">
                <Form.Label className="common-label">
                  Question<span className="ms-1 red-color-text">*</span>
                </Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    className="common-input"
                    value={faqInput?.question}
                    // onChange={(e) => {
                    //   setFaqInput({
                    //     ...faqInput,
                    //     question: e.target.value,
                    //   });
                    // }}
                    onChange={(e) => fnInputChange(e.target.value, "question")}
                    isInvalid={faqInput?.errors?.question}
                  />
                  {faqInput?.errors?.question && (
                    <Form.Control.Feedback type="invalid">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={faqInput?.errors?.question}
                        />
                      </span>
                    </Form.Control.Feedback>
                  )}
                </div>
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="form-group ">
                <Form.Label className="common-label">
                  Answer<span className="ms-1 red-color-text">*</span>
                </Form.Label>
                {/* <div className="position-relative">
                  <Form.Control
                    as="textarea"
                    className="common-input"
                    style={{ minHeight: "100px" }}
                    value={faqInput?.answer}
                    onChange={(e) => {
                      setFaqInput({
                        ...faqInput,
                        answer: e.target.value,
                      });
                    }}
                    isInvalid={faqInput?.errors?.answer}
                  />
                  {faqInput?.errors?.answer && (
                    <Form.Control.Feedback type="invalid">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={faqInput?.errors?.answer}
                        />
                      </span>
                    </Form.Control.Feedback>
                  )}
                </div> */}
                <div className="position-relative">
                  <div
                    className={`${
                      faqInput?.errors?.answer && "error-border-line"
                    }`}
                  >
                    <CKeditorComponent
                      onChange={handleCKEditor}
                      tag="answer"
                      value={faqInput?.answer}
                    />
                  </div>
                  {faqInput?.errors?.answer && (
                    <p className="error-line">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={faqInput?.errors?.answer}
                        />
                      </span>
                    </p>
                  )}
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <button className="grey-btn w-auto" onClick={closeModal}>
            Cancel
          </button>
          <button
            className="blue-btn w-auto"
            onClick={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            Save
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddEditFaqModal;
